// Import the active color scheme
import {getActiveColors} from "./colorSchemes";

// Use the active color scheme
const colors = getActiveColors();

export default colors;
